(function () {
  var COOKIE_NAME = 'el_cookie_consent';
  var COOKIE_DAYS = 365;
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }
  function hideBanner(banner) {
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
    setTimeout(function () { banner.style.display = 'none'; }, 500);
  }
  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('el-cookie-banner');
    if (!banner) return;
    if (getCookie(COOKIE_NAME)) {
      banner.style.display = 'none';
      return;
    }
    setTimeout(function () {
      banner.classList.add('is-visible');
      banner.setAttribute('aria-hidden', 'false');
    }, 800);
    document.getElementById('el-cookie-accept').addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'accepted', COOKIE_DAYS);
      hideBanner(banner);
    });
    document.getElementById('el-cookie-refuse').addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'refused', COOKIE_DAYS);
      hideBanner(banner);
    });
  });
})();